import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { REGEX } from "../utils/validations";
import { sendEmail } from "../api/sendEmailApi";
import { createContact, getContactInfo } from "../api/contactApi";

import styles from "../styles/Contact.module.css";
import Success from "../components/Success";
import { useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import { contactEmailFormatter } from "../utils/Helper";
import { localization } from "../hooks/useLocalization";

async function setinfo() {
  const res = await getContactInfo();
  if (res.data.length > 0) {
    return res.data[0];
  }
}

export async function getServerSideProps(ctx) {
  const propsdata = {
    info: null,
  };
  try {
    propsdata.info = await setinfo();

    return {
      props: propsdata,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

const contact = ({ info }) => {
  const router = useRouter();
  const url = router.pathname;
  const [formHandle, setFormHandle] = useState({
    email: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [url]);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      subject: "",
      description: "",
    },
  });

  const { mutate: emailsend } = useMutation(sendEmail, {
    onSuccess: async (res) => {
      const Json = await res.json();

      if (res.status === 200) {
        // alert("thanks");
        // setShowSuccessMessage(true);
        return;
      }
    },
  });

  const { mutate, isError, isLoading } = useMutation(createContact, {
    onSuccess: async (res) => {
      const Json = await res.json();

      if (res.status === 200) {
        setShowSuccessMessage(true);
        return;
      }
    },
  });

  const TextMessage = localization()

  const submit = async (data, e) => {
    e.preventDefault();
    mutate(data);
    emailsend({
      to: data.email,
      subject: data.subject,
      html: contactEmailFormatter(data),
    });
    emailsend({
      to: "shaivam@shaivam.org",
      cc: data.email,
      subject: data.subject,
      html: contactEmailFormatter(data),
    });
    reset({
      name: "",
      email: "",
      phone: "",
      subject: "",
      description: "",
    });
    setFormHandle({ ...formHandle, email: "" });
  };

  return (
    <>
      <Head>
        <title>{info?.attributes?.Sub_category_Title}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta
          name="description"
          content={info?.attributes?.seo?.metaDescription}
        />
        <meta name="keywords" content={info?.attributes?.seo?.metaKeywords} />
        <meta
          property="og:title"
          content={info?.attributes?.seo?.metaTitle}
          key="og:title"
        />
        <meta
          property="og:description"
          content={info?.attributes?.seo?.metaDescription}
          key="og:description"
        />
        <link rel="icon" href="/assests/icons/logo.png" />
      </Head>
      <div className={styles.contactWrapper}>
        <div className={styles.contactForm}>
          <div className={styles.head}>
          <h1>{TextMessage?.ContactPage?.Heading}</h1>
            <p>{TextMessage?.ContactPage?.subHeading}</p>
            <div className={styles.phone}>
              <span>
                <img src="/assests/icons/email.svg" alt="" />{" "}
                shaivam@shaivam.org
              </span>
            </div>
          </div>
          <form onSubmit={handleSubmit(submit)} className={styles.form}>
            <p>{TextMessage?.ContactPage?.Fields?.name}</p>
            <input
              {...register("name", {
                required: "Please fill the  name",
                pattern: {
                  value: REGEX.name,
                  message: "Please don't include special characters or numbers",
                },
              })}
              type="text"
              required
            />
            <p style={{ color: "red" }}>{errors?.name?.message}</p>
            <p>{TextMessage?.ContactPage?.Fields?.email}</p>
            <input
              {...register("email", {
                required: "Please enter a Email Address",
                pattern: {
                  value: REGEX.email,
                  message: "Not a valid Email Address",
                },
              })}
              value={formHandle.email?.trim()}
              onInput={(e) =>
                setFormHandle({ ...formHandle, email: e.target.value })
              }
              type="text"
              required
            />
            <p style={{ color: "red" }}>{errors?.email?.message}</p>
            <p>{TextMessage?.ContactPage?.Fields?.number}</p>
            <input
              {...register("phone", {
                required: "Please enter a phone number",
              })}
              type="number"
              min={0}
              required
            />
            <p style={{ color: "red" }}>{errors?.phone?.message}</p>

            <p>{TextMessage?.ContactPage?.Fields?.subject}</p>

            <input
              {...register("subject", {
                required: "Please enter a subject Address",
              })}
              type="text"
              required
            />
            <p>{TextMessage?.ContactPage?.Fields?.description}</p>
            <textarea
              {...register("description", {
                required: "Please enter description",
              })}
              name="description"
              id=""
              cols="30"
              rows="5"
            ></textarea>
            <div className="btn">
              <button type="submit" style={{ cursor: "pointer" }}>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* <Loading /> */}
      {showSuccessMessage === true && (
        <Success
          heading={"Your Query sent Successfully"}
          text={TextMessage?.ContactPage?.Successfull}
          setShowSuccessMessage={setShowSuccessMessage}
          path={""}
        />
      )}
    </>
  );
};

export default contact;
